import { fetchJson } from './api_helpers';
import { API_BASE_URL } from '../constants';

/**
 * @param {{ startDate?: string, endDate?: string }} [options] - Optional YYYY-MM date range filter
 * @returns {Promise<Record<string, { language?: Record<string, number>, platform?: Record<string, number> }>>}
 */
export function getLandingPageStatistics({ startDate, endDate } = {}) {
  const params = new URLSearchParams();
  if (startDate) params.set('start_date', startDate);
  if (endDate) params.set('end_date', endDate);
  const qs = params.toString();
  return fetchJson(`${API_BASE_URL}/awatch/landing_page/statistics${qs ? `?${qs}` : ''}`);
}

export function getAntisemitismTypes() {
  return fetchJson(`${API_BASE_URL}/awatch/landing_page/antisemitism_types`);
}

function sanitizeSubjectKey(key) {
  return String(key).replace(/^"+|"+$/g, '').trim();
}

export function getInteractions() {
  return fetchJson(`${API_BASE_URL}/awatch/landing_page/interactions`);
}

export function getSubjects() {
  return fetchJson(`${API_BASE_URL}/awatch/landing_page/subjects`).then((raw) => {
    if (!raw || typeof raw !== 'object') return {};
    return Object.fromEntries(
      Object.entries(raw).map(([k, v]) => [sanitizeSubjectKey(k), v])
    );
  });
}
